// Web shim for NativeModules.AudioRecorder using MediaRecorder API

let mediaRecorder = null;
let audioChunks = [];
let currentAudio = null;

const AudioRecorder = {
  async startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioChunks = [];
      mediaRecorder = new MediaRecorder(stream);
      mediaRecorder.ondataavailable = (e) => {
        audioChunks.push(e.data);
      };
      mediaRecorder.start();
      return 'web-recording';
    } catch (err) {
      throw new Error('Microphone access denied: ' + err.message);
    }
  },

  async stopRecording() {
    return new Promise((resolve, reject) => {
      if (!mediaRecorder) {
        reject(new Error('No active recording'));
        return;
      }

      mediaRecorder.onstop = () => {
        const blob = new Blob(audioChunks, { type: 'audio/webm' });
        const uri = URL.createObjectURL(blob);
        // Stop all tracks
        mediaRecorder.stream.getTracks().forEach((t) => t.stop());
        mediaRecorder = null;
        audioChunks = [];
        resolve(uri);
      };

      mediaRecorder.stop();
    });
  },

  async cancelRecording() {
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stream.getTracks().forEach((t) => t.stop());
      mediaRecorder.stop();
      mediaRecorder = null;
      audioChunks = [];
    }
  },

  async playAudio(url) {
    await this.stopPlayback();
    currentAudio = new Audio(url);
    await currentAudio.play();
  },

  async stopPlayback() {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      currentAudio = null;
    }
  },
};

export default AudioRecorder;
